export default "__VITE_ASSET__BxNVlVTw__"